module.exports = __webpack_public_path__ + "static/img/home-n.31d38e5e.png";